var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkDone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.313,18H1.688A1.689,1.689,0,0,1,0,16.313V3.188A1.689,1.689,0,0,1,1.688,1.5H3.656V.843a.844.844,0,0,1,1.688,0V1.5h5.813V.843a.844.844,0,0,1,1.688,0V1.5h5.812V.843a.844.844,0,0,1,1.688,0V1.5h1.969A1.689,1.689,0,0,1,24,3.188V16.313A1.689,1.689,0,0,1,22.313,18ZM1.688,7.5v8.813H22.313V7.5Zm0-4.312V5.812H22.313V3.188H20.344v.468a.844.844,0,1,1-1.687,0V3.188H12.844v.468a.844.844,0,1,1-1.687,0V3.188H5.343v.468a.844.844,0,1,1-1.688,0V3.188Zm13.58,12.117a.781.781,0,0,1-.556-.23l-.082-.082-.021-.022-.022-.021-1.99-1.99a.844.844,0,1,1,1.193-1.193l1.474,1.474L19.88,8.627a.785.785,0,0,1,1.111,0l.082.082a.785.785,0,0,1,0,1.111l-5.25,5.255A.781.781,0,0,1,15.267,15.305ZM9.691,13.594H3.809A.81.81,0,0,1,3,12.785v-.07a.81.81,0,0,1,.809-.809H9.691a.81.81,0,0,1,.809.809v.07A.81.81,0,0,1,9.691,13.594Zm3-2.906H3.809A.81.81,0,0,1,3,9.879V9.808A.81.81,0,0,1,3.809,9h8.883a.809.809,0,0,1,.808.808v.071A.809.809,0,0,1,12.692,10.688Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkDone);
export default __webpack_public_path__ + "static/media/workDone.fca4fbc3.svg";
export { ForwardRef as ReactComponent };